import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { acmeButtonSx, acmeButtonSizeSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

const VARIANT_MAP = {
  default: acmeButtonSx.primary,
  primary: acmeButtonSx.primary,
  'primary-pill': acmeButtonSx.primaryPill,
  destructive: acmeButtonSx.destructive,
  outline: acmeButtonSx.outline,
  secondary: acmeButtonSx.secondary,
  ghost: acmeButtonSx.ghost,
  link: acmeButtonSx.link,
};

/**
 * shadcn-compatible button (see Tanplates/button.js).
 * @param {'default'|'primary'|'primary-pill'|'destructive'|'outline'|'secondary'|'ghost'|'link'} [variant='default']
 * @param {'default'|'sm'|'lg'|'icon'} [size='default']
 */
const Button = React.forwardRef(function Button(
  { variant = 'default', size = 'default', sx, ...props },
  ref,
) {
  const baseSx = VARIANT_MAP[variant] || acmeButtonSx.primary;
  const sizeSx = acmeButtonSizeSx[size] || acmeButtonSizeSx.default;
  const muiVariant =
    variant === 'outline' ? 'outlined' : variant === 'link' || variant === 'ghost' ? 'text' : 'contained';

  return (
    <MuiButton
      ref={ref}
      variant={muiVariant}
      disableElevation
      sx={mergeSx(baseSx, sizeSx, sx)}
      {...props}
    />
  );
});

export default Button;
